import { render, staticRenderFns } from "./Section3.vue?vue&type=template&id=065c5b7e&scoped=true"
import script from "./Section3.vue?vue&type=script&lang=js"
export * from "./Section3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065c5b7e",
  null
  
)

export default component.exports